import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bcbae05c&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=bcbae05c&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbae05c",
  null
  
)

export default component.exports